import React from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss'
import {useDispatch, useSelector} from "react-redux";

import {setMatrixSellModalStatus, setMatrixSellWarningModalStatus} from "../../store/cabinet/action";
import cfpIcon from "../../theme/assets/other/ftf_cfp_icon.png";



const CabinetMatrixSellWarningModal = () => {
    const dispatch = useDispatch();

    const matrixSellWarningModalStatus = useSelector(store => store.cabinet.matrixSellWarningModalStatus);

    const closeModal = () =>{
        dispatch(setMatrixSellWarningModalStatus(false));
    }

    const mainBtnHandler = () =>{
        closeModal();
        localStorage.setItem('ftf-swms', 'accept');
        dispatch(setMatrixSellModalStatus(true));
    }

    return (
        <Popup
            open={matrixSellWarningModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={`${Styles.modalContainer}`}>
                <div className={`${Styles.modalCloseBtn}`} onClick={()=>{closeModal()}}>
                    <div/>
                    <div/>
                </div>
                <div className={`${Styles.modalContentWrap}`}>
                    <div className={`${Styles.balanceRow}`}>
                        <div className={`${Styles.balanceRowName}`}>Your tokens balance:</div>
                        <div className={`${Styles.balanceRowValueBox}`}>
                            <div className={`${Styles.balanceRowValueBoxIcon}`}>
                                <img src={cfpIcon} alt="cfp token"/>
                            </div>
                            <div className={`${Styles.balanceRowValue}`}>454</div>
                        </div>
                    </div>
                    <div className={`${Styles.note}`}>
                        By clicking on the <span>“Sell Tokens”</span> button you realize that you will no longer be able to return your tickets, they will be sold automatically
                    </div>
                    <div className={`${Styles.ftfBackgroundYellowBtn}`} onClick={()=>{mainBtnHandler()}}>Yes, I understand!</div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetMatrixSellWarningModal;
